<template>
	<div id="body">
		<div class="overlay">
			<div class="container">
				<div class="row">
					<div class="col-md-6 col-sm-6">
						<div class="page-title wow bounceInLeft animated" ata-wow-delay="0.4s">
							<h1>{{home}}</h1></div>
					</div>
					<div class="col-md-6 col-sm-6">
						<ul class="page-breadcrumb wow bounceInRight animated" ata-wow-delay="0.4s">
							<li>
								<router-link to="/index">{{lang == 1 ? '首页' : 'Home'}}</router-link>
							</li>
							<li class="active">
								<router-link to="/calendar">{{home}}</router-link>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div class="page-seperate"></div>
		<div id="content">
			<div class="container fadeInDown animated">
				<div class="row">
					<div id="calendar" class="col-md-12 col-sm-12 col-xs-12">
						<div class="calendar">
							<div class="col-xs-2 last" @click="onLast">
								<i class="glyphicon glyphicon-menu-left"></i>
								<span>{{lastMonth}}</span>
							</div>
							<div class="col-xs-8 year-box">
								<div class="year">
									<i class="glyphicon glyphicon-menu-left" @click="onLastYear"></i>
									<span style="font-size: 18px;line-height: 18px;margin: 0 10px;">{{showYear}}</span>
									<i class="glyphicon glyphicon-menu-right" @click="onNextYear"></i>
								</div>
								<div>{{showMonth}}</div>
							</div>
							<div class="col-xs-2 next" @click="onNext">
								<span>{{nextMonth}}</span>
								<i class="glyphicon glyphicon-menu-right"></i>
							</div>
						</div>
						<div class="tab-box">
							<div class="col-xs-3 tab" :class="type == 0 ? 'active' : ''" @click="onTab(0)">{{lang == 1 ? '月' : 'Month'}}</div>
							<div class="col-xs-3 tab" :class="type == 1 ? 'active' : ''" @click="onTab(1)">{{lang == 1 ? '列表' : 'List'}}</div>
							<div class="col-xs-3 tab" :class="type == 2 ? 'active' : ''" @click="onTab(2)">{{lang == 1 ? '周' : 'Week'}}</div>
							<div class="col-xs-3 tab" :class="type == 3 ? 'active' : ''" @click="onTab(3)">{{lang == 1 ? '天' : 'Day'}}</div>
						</div>
						<div class="head"  v-if="type == 0">
							<div>{{lang == 1 ? '周日' : 'Su'}}</div>
							<div>{{lang == 1 ? '周一' : 'Mo'}}</div>
							<div>{{lang == 1 ? '周二' : 'Tu'}}</div>
							<div>{{lang == 1 ? '周三' : 'We'}}</div>
							<div>{{lang == 1 ? '周四' : 'Th'}}</div>
							<div>{{lang == 1 ? '周五' : 'Fr'}}</div>
							<div>{{lang == 1 ? '周六' : 'Sa'}}</div>
						</div>
						<!--月-->
						<div class="body" v-if="show && type == 0">
							<div class="item startWeek" v-for="item in startWeek">{{lastMonth}}</div>
							<div class="item content" v-for="(item,index) in maxDay">
								<p class="day" :class="currIndex == 0 && currDay == index + 1 ? 'active' : ''">{{index + 1}}</p>
								<div class="day-body"></div>
							</div>
							<div class="item nextNum" v-for="item in nextNum">{{nextMonth}}</div>
						</div>
						<!--月-end-->
						<!--列表-->
						<div class="list" v-if="show && type != 0">
							<div class="item" v-for="(item,index) in list">
								<div class="list-time">{{item.time}}</div>
								<div class="list-title">{{item.title}}</div>
								<div class="list-scope">
									<div class="left"><i class="glyphicon glyphicon-calendar"></i>{{item.timerange}}</div><div class="right"><i class="glyphicon glyphicon-dashboard"></i>{{item.daterange}}</div>
								</div>
								<div class="list-image" v-if="item.cover_image">
									<img style="width: 300px;" :src="'http://admin.brlsea.org' + item.cover_image"/>
								</div>
								<div class="list-content" v-html="item.content"></div>
								<div class="list-link" v-if="item.click_url">
									<a :href="item.click_url">{{item.click_title}}</a>
								</div>
							</div>
							<div class="no-data" v-if="list.length == 0">
								{{lang == 1 ? '暂无活动' : 'No activity'}}
							</div>
						</div>
						<!--列表-end-->
					</div>
					<!--Sidebar Section-->
					<!--<div class="col-md-4 col-sm-5 col-xs-12">
						<div class="sidebar">
							<aside id="search-1" class="widget widget_search wow fadeInDown" data-wow-delay="0.4s">
								<div class="section-header wow fadeInDown" data-wow-delay="0.4s">
									<h3 class="widget-title">Search</h3></div>
								<form method="get" id="searchform" class="search-form" action="" ref="form">
									<label><input type="search" class="search-field" :placeholder="lang == 1 ? '搜索' : 'Search'" v-model="search" /></label>
									<label><input type="button" class="search-submit" :value="lang == 1 ? '搜索' : 'Search'" @click="onSubmit"></label>
								</form>
							</aside>
							<aside id="recent-posts-1" class="widget widget_recent_entries wow fadeInDown" data-wow-delay="0.4s">
								<div class="section-header wow fadeInDown" data-wow-delay="0.4s">
									<h3 class="widget-title">{{lang == 1 ? '近期文章' : 'Latest Release' }}</h3></div>
								<ul>
									<li v-for="item in right">
										<router-link :to="{name:'article',params: { id: item.article_id }}">{{item.title}}</router-link>
									</li>
								</ul>

							</aside>
						</div>
					</div>-->
					<!--Sidebar Section-->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { getArticle, getActivity } from '../api/api';
	export default {
		data() {
			return {
				show: false,
				search: '',
				right: '',
				type: 0,
				monthArr: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
				weekArr: ['星期日','星期一','星期二','星期三','星期四','星期五','星期六'],
				cyrrTime: '', //当前时间戳
				showYear: '', //显示的年份
				currYear: '', //当前实际年份
				currMonth: '', //当前实际月份
				currDay: 0,//当前实际号
				currIndex: 0, //加或减少月份的值
				showMonth: '', //显示的月份
				lastMonth: '', //上一个月月份
				nextMonth: '', //下一个月月份
				startWeek: 0,
				maxDay: 0,
				nextNum: 0,
				list: [],
				home: ''
			};
		},
		props: ['lang'],
		methods: {
			onTab(type) {
				if(type == this.type) {
					return false;
				}
				this.type = type;
				this.currIndex = 0;
				if(type == 0 || type == 1) {
					this.updataTime();
				}else if(type == 2) {
					this.updataTime2();
				}else if(type == 3) {
					this.updataTime3();
				}
			},
			updataTime() {
				this.show = false;
				let timestamp = new Date(this.currYear, (this.currMonth + this.currIndex), 0).getTime();//！天数为0且用逗号隔开时，月份不需要减1；
				let time = new Date(timestamp);
				let year = time.getFullYear();
				let month = time.getMonth();
				this.showYear = year;
				this.showMonth = this.monthArr[month];
				let last = time.getMonth() - 1;
				let next = time.getMonth() + 1;
				if(last == -1) {
					last = 11;
				}
				if(next == 12) {
					next = 0;
				}
				this.lastMonth = this.monthArr[last];
				this.nextMonth = this.monthArr[next];
				let time2 = new Date(this.showYear, month, 1);
				this.maxDay = time.getDate();
				this.startWeek = time2.getDay();
				this.nextNum = 42 - (this.maxDay + this.startWeek);
				if(this.nextNum >= 7) {
					this.nextNum = this.nextNum - 7;
				}
				let start_date = new Date(this.showYear, month, 1).getTime() / 1000;
				let end_date = new Date(this.showYear, month, this.maxDay).getTime() / 1000;
				if(this.type == 0) {
					this.onGetDataMonth(start_date, end_date);
				} else if(this.type == 1) {
					this.onGetDataList(start_date, end_date);
				}
			},
			updataTime2() {
				this.show = false;
				let timestamp = new Date(this.currYear, this.currMonth - 1, this.currDay + 7 * this.currIndex).getTime();//！天数为0且用逗号隔开时，月份不需要减1；否则需要减一
				let time = new Date(timestamp);
				let year = time.getFullYear();
				let month = time.getMonth();
				this.showYear = year;
				let sweek = time.getDay();
				let eweek = 6 - sweek;
				let sTime = new Date(timestamp - sweek * 86400000);
				let eTime = new Date(timestamp + eweek * 86400000);
				let last = sTime.getMonth();
				let next = eTime.getMonth();
				if(last == -1) {
					last = 11;
				}
				if(next == 12) {
					next = 0;
				}
				let lastDay = new Date(sTime.getTime() - 7 * 86400000);
				let nextDay = new Date(eTime.getTime() + 86400000);
				this.lastMonth = this.monthArr[lastDay.getMonth()] + ' ' + (lastDay.getDate() < 10 ? ('0' + lastDay.getDate()) : lastDay.getDate());
				this.nextMonth = this.monthArr[nextDay.getMonth()] + ' ' + (nextDay.getDate() < 10 ? ('0' + nextDay.getDate()) : nextDay.getDate());
				
				this.showMonth = this.monthArr[last]+ '.' + (sTime.getDate() < 10 ? ('0' + sTime.getDate()) : sTime.getDate()) + " - " + this.monthArr[next] + '.' + (eTime.getDate() < 10 ? ('0' + eTime.getDate()) : eTime.getDate());
				
				let start_date = sTime.getTime() / 1000;
				let end_date = eTime.getTime() / 1000;
				this.onGetDataList(start_date, end_date);			
			},
			updataTime3() {
				this.show = false;
				let timestamp = new Date(this.currYear, this.currMonth - 1, this.currDay + this.currIndex).getTime();//！天数为0且用逗号隔开时，月份不需要减1；否则需要减一
				let time = new Date(timestamp);
				let year = time.getFullYear();
				let month = time.getMonth();
				this.showYear = year;
				let sweek = time.getDay();
				let eweek = 6 - sweek;
				let sTime = new Date(timestamp - sweek * 86400000);
				let eTime = new Date(timestamp + eweek * 86400000);
				let last = sTime.getMonth();
				let next = eTime.getMonth();
				if(last == -1) {
					last = 11;
				}
				if(next == 12) {
					next = 0;
				}
				let lastDay = new Date(time.getTime() - 86400000);
				let nextDay = new Date(time.getTime() + 86400000);
				this.lastMonth = this.monthArr[lastDay.getMonth()] + ' ' + (lastDay.getDate() < 10 ? ('0' + lastDay.getDate()) : lastDay.getDate());
				this.nextMonth = this.monthArr[nextDay.getMonth()] + ' ' + (nextDay.getDate() < 10 ? ('0' + nextDay.getDate()) : nextDay.getDate());
				this.showMonth = this.monthArr[month]+ ' ' + (time.getDate() < 10 ? ('0' + time.getDate()) : time.getDate());
				let start_date = time.getTime() / 1000;
				let end_date = time.getTime() / 1000;
				this.onGetDataList(start_date, end_date);	
			},
			onGetDataMonth(start_date, end_date) {
				let that = this;
				getActivity({
					lang: this.lang,
					start_date: start_date,
					end_date: end_date,
				}).then(res => {
					that.show = true;
					if(res.code == 1) {
						setTimeout(()=>{
							res.data.forEach((val,ind)=>{
								let dom = '<a href="javascript:;" class="activity">'+ val.title +'</a>';
								let i = parseInt(val.day) - 1;
								$('.day-body').eq(i).append(dom);
								let content = '<div style="width:244px;height:auto;max-height:500px;overflow-x:hidden;overflow-y:auto;">';
//								content += '<div class="lay-title">'+ val.title +'</div>';
								content += '<div class="lay-time"><div class="left"><i class="glyphicon glyphicon-calendar"></i>'+ val.daterange +'</div><div class="right"><i class="glyphicon glyphicon-dashboard"></i>'+ val.timerange +'</div></div>'
								if(val.cover_image){
									content += '<div class="lay-img"><img style="width: 100px;" src="http://admin.brlsea.org'+val.cover_image+'" /></div>'
								}
								content += '<div class="lay-content">'+ val.content +'</div>';
								if(val.click_url){
									content += '<div class="lay-link"><a href="'+ val.click_url +'">' + val.click_title + '</a></div>'
								}
								content += '</div>';
								jQuery('.day-body').eq(i).find('.activity').popover({
									html: true,
									content: content,
									trigger: 'focus',
									title: val.title,
									placement: 'auto',
									selector: $('.day-body').eq(i)
								})
							})
						},100)
					}
				})
			},
			onGetDataList(start_date, end_date){
				let that = this;
				getActivity({
					start_date: start_date,
					end_date: end_date,
				}).then(res => {
					that.show = true;
					if(res.code == 1) {
						res.data.forEach((val,ind)=>{
							let str = val.start_date.split('.');
							let time = new Date(str[0]+'/'+str[1]+'/'+str[2]);
							let dd = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
							let mm = that.monthArr[time.getMonth()];
							let week = that.weekArr[time.getDay()];
							val.time = dd + '.' + mm + '.' + week;
						})
						that.list = res.data;
					}
				})
			},
			onLast() {
				this.currIndex = this.currIndex - 1;
				if(this.type == 0 || this.type == 1) {
					this.updataTime();
				}else if(this.type == 2){
					this.updataTime2();
				}else if(this.type == 3){
					this.updataTime3();
				}
			},
			onNext() {
				this.currIndex = this.currIndex + 1;
				if(this.type == 0 || this.type == 1) {
					this.updataTime();
				}else if(this.type == 2){
					this.updataTime2();
				}else if(this.type == 3){
					this.updataTime3();
				}
			},
			onLastYear() {
				this.currYear -= 1;
				if(this.type == 0 || this.type == 1) {
					this.updataTime();
				}else if(this.type == 2){
					this.updataTime2();
				}else if(this.type == 3){
					this.updataTime3();
				}
			},
			onNextYear() {
				this.currYear += 1;
				if(this.type == 0 || this.type == 1) {
					this.updataTime();
				}else if(this.type == 2){
					this.updataTime2();
				}else if(this.type == 3){
					this.updataTime3();
				}
			},
			onSubmit() {
				this.$router.push({
					name: 'search',
					params: {
						search: this.search
					}
				})
			},
			onGetArticleRight() {
				let that = this;
				getArticle({
					lang: this.lang,
					page: 1,
					size: 3
				}).then(res => {
					if(res.code == 1) {
						that.right = res.data;
					}
				})
			},
		},
		created() {
			if(this.lang == 2){
				this.monthArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
				this.weekArr = ['Su','Mo','Tu','We','Th','Fr','Sa'];
			}
			this.currYear = new Date().getFullYear();
			this.currMonth = new Date().getMonth() + 1; //因为该参数需要new Date和显示，所以需要 + 1;
			this.currDay = new Date().getDate();
			this.updataTime();
			this.onGetArticleRight();
		},
		mounted() {
			this.home = $(".menu-item.active a").text();
			$("body").on("mousemove",".activity",function(){
				$(this).focus();
			})
//			$("body").on("mouseend",".activity",function(){
//				$(this).blur();
//			})
		}
	};
</script>

<style scoped="scoped">
	#body {
		font-weight: 500;
	}
	
	.calendar {
		height: 85px;
		display: flex;
	}
	
	.last,
	.next,
	.year-box {
		color: #fff;
		font-size: 14px;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		background: #CE1C28;
		box-sizing: border-box;
		-ms-user-select: none;
		-moz-user-select: none;
		-webkit-user-select: none;
		border-bottom: 1px solid #fff;
	}
	
	.last {
		border-right: 1px solid #fff;
	}
	
	.next {
		border-left: 1px solid #fff;
		justify-content: flex-end;
	}
	
	.year-box {
		flex-direction: column;
		justify-content: center;
	}
	
	.tab-box {
		height: 50px;
		text-align: center;
		line-height: 50px;
	}
	
	.tab-box .tab {
		color: #fff;
		font-size: 16px;
		background: #CE1C28;
		border-right: 1px solid #fff;
		box-sizing: border-box;
		-ms-user-select: none;
		-moz-user-select: none;
		-webkit-user-select: none;
	}
	
	.tab-box .tab.active {
		color: #CE1C28;
		background: #FFFFFF;
	}
	
	.tab-box .tab:last-child {
		border-right: none;
	}
	
	.head {
		font-size: 17px;
		text-align: center;
		height: 31px;
		display: flex;
		align-content: flex-start;
		flex-flow: row wrap;
	}
	
	.head div {
		border: 1px solid #E9E9E9;
		flex: 0 0 14.286%;
		border-right: none;
		background: #fff;
		border-bottom: none;
	}
	
	.head div:last-child {
		border-right: 1px solid #E9E9E9;
	}
	
	.body {
		margin-bottom: 80px;
		width: 100%;
		display: flex;
		align-content: flex-start;
		flex-flow: row wrap;
	}
	
	.body .item {
		background: #FFFFFF;
		flex: 0 0 14.285%;
		height: 250px;
		border: 1px solid #E9E9E9;
		border-top: none;
		border-right: none;
	}
	
	.body .item:nth-child(7n) {
		border-right: 1px solid #E9E9E9;
	}
	
	.body .item.startWeek {
		background: #F9F9F9;
		text-align: center;
		font-size: 14px;
	}
	
	.body .item.nextNum {
		background: #F9F9F9;
		text-align: center;
		font-size: 14px;
	}
	
	.body .item .day {
		font-size: 14px;
		line-height: 20px;
		height: 20px;
		text-align: center;
		background: #E0E0E0;
	}
	
	.body .item .active {
		background: #CE1C28;
		color: #FFFFFF;
	}
	
	.list {
		margin-bottom: 80px;
	}
	
	.list .no-data {
		background: #FFFFFF;
		border: 1px solid #E9E9E9;
		border-top: none;
		margin: 0 -1px 0 -1px;
		text-align: center;
		line-height: 300px;
	}
	
	.list .item{
		background: #FFFFFF;
		border: 1px solid #E9E9E9;
		border-top: none;
		margin: 0 -1px 0 -1px;
	}
	
	.list .item .list-time {
		height: 30px;
		line-height: 30px;
		font-size: 16px;
		background: #CE1C28;
		color: #FFFFFF;
		padding: 0 20px;
	}
	
	.list .item .list-time:first-child {
		border-top: 1px solid #E9E9E9;
	}
	
	.list .item .list-title {
		padding: 0 20px;
		font-size: 16px;
		margin-bottom: 5px;
		line-height: 30px;
		font-weight: 500;
	}
	
	.list .item .list-scope {
		display: flex;
		padding: 0 20px;
		font-size: 14px;
		align-items: center;
		font-weight: 400;
		flex-wrap: wrap;
	}
	
	.list .item .list-scope div i {
		margin-right: 15px;
	}
	
	.list .item .list-scope .left{
		margin-right: 50px;
	}
	
	.list .item .list-image {
		padding: 0 20px;
		margin-top: 10px;
		margin-bottom: 10px;
	}
	
	.list .item .list-content {
		padding: 0 20px;
		line-height: 1.5;
		margin-bottom: 5px;
	}
	
	.list .item .list-link {
		padding: 0 20px;
		line-height: 30px;
		margin-bottom: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/calendar.vue